import { useEffect, useState } from "react";
import claimService from "../../../services/vo/claim-service";
import Loading from "../shared-components/loading/Loading";
import { useTranslation } from "react-i18next";

function ClaimThankYouPage(props) {
  const [regNo, setRegNo] = useState();
  const [claimId, setClaimId] = useState();
  const [pdfUrl, setPdfUrl] = useState();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    var url = new URL(window.location.href);
    const queryParams = new URLSearchParams(window.location.search);
    const langParam = queryParams.get("lang");
    switch (langParam) {
      case "sv-SE":
        setCountry("sv-SE");
        break;
      case "nn-NO":
        setCountry("nn-NO");
        break;
      case "fi-FI":
        setCountry("fi-FI");
        break;
      case "da-DK":
        setCountry("da-DK");
        break;
      default:
        setCountry("en-GB");
        break;
    }
    setRegNo(atob(url.searchParams.get("regno")));
    setClaimId(atob(url.searchParams.get("claimId")));
  }, []);

  const getClaimPDF = async () => {
    setLoading(true);
    await claimService
      .GetClaimPDF(claimId)
      .then((response) => {
        setPdfUrl(response.data.Url);
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(false);
  };

  useEffect(() => {
    if (claimId != null) {
      getClaimPDF(claimId);
    }
  }, [claimId]);

  return (
    <div class="page-main-wrapper">
      {loading ? <Loading></Loading> : ""}
      <div style={{ display: "flex", justifyContent: "center" }}>
        {country == "en-GB" ? (
          <div style={{ marginTop: 50, maxWidth: 500 }}>
            <h1 style={{ textAlign: "center" }}>Thank you for your claim!</h1>
            <p style={{ textAlign: "center" }}>
              Your case regarding damage to vehicle with registration number{" "}
              {regNo}
              &nbsp; has been assigned damage ID {claimId} Damage response is
              sent after assessment to the workshop.
            </p>
            <p style={{ textAlign: "center", marginTop: 40, marginBottom: 40 }}>
              <a href={pdfUrl} target="_blank">
                Click here to print the claim report
              </a>
            </p>
            <p style={{ textAlign: "center" }}>
              Sincerely, <br />
              AutoConcept Insurance
            </p>
          </div>
        ) : (
          <div style={{ marginTop: 50, maxWidth: 500 }}>
            <h1 style={{ textAlign: "center" }}>
              {t("claim_thankyou.subtitle")}
            </h1>
            <p style={{ textAlign: "center" }}>
              {t("claim_thankyou.description1")} {regNo}
              &nbsp; {t("claim_thankyou.description2")} {claimId}{" "}
              {t("claim_thankyou.description3")}
            </p>
            <p style={{ textAlign: "center", marginTop: 40, marginBottom: 40 }}>
              <a href={pdfUrl} target="_blank">
                {t("claim_thankyou.claim_print")}
              </a>
            </p>
            <p style={{ textAlign: "center" }}>
              {t("claim_thankyou.signature")}, <br />
              AutoConcept Insurance
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClaimThankYouPage;
